import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      categoria: 'Conta e Cadastro',
      perguntas: [
        {
          pergunta: 'Como criar uma conta na BOILX?',
          resposta: 'Para criar uma conta, clique em "Cadastrar" no menu superior, preencha seus dados pessoais e confirme seu e-mail. O processo é rápido e gratuito.',
        },
        {
          pergunta: 'Preciso pagar para me cadastrar?',
          resposta: 'Não! O cadastro na BOILX é totalmente gratuito. Você só paga se optar por um dos nossos planos premium para destacar seus anúncios.',
        },
        {
          pergunta: 'Esqueci minha senha. O que fazer?',
          resposta: 'Clique em "Entrar" e depois em "Esqueci minha senha". Informe seu e-mail cadastrado e enviaremos um link para redefinir sua senha.',
        },
      ],
    },
    {
      categoria: 'Anúncios',
      perguntas: [
        {
          pergunta: 'Como criar um anúncio?',
          resposta: 'Após fazer login, clique em "Anunciar" no menu. Preencha as informações do animal, adicione fotos e vídeos, e publique. Seu anúncio será revisado e publicado em até 24 horas.',
        },
        {
          pergunta: 'Quantas fotos posso adicionar?',
          resposta: 'Você pode adicionar até 20 fotos por anúncio. Recomendamos usar fotos de alta qualidade para atrair mais interessados.',
        },
        {
          pergunta: 'Meu anúncio foi reprovado. Por quê?',
          resposta: 'Anúncios podem ser reprovados por informações incompletas, fotos inadequadas ou violação das nossas políticas. Verifique seu e-mail para mais detalhes.',
        },
        {
          pergunta: 'Por quanto tempo meu anúncio fica ativo?',
          resposta: 'Anúncios ficam ativos por 60 dias. Você pode renovar ou editar a qualquer momento pelo seu painel.',
        },
      ],
    },
    {
      categoria: 'Pagamentos e Planos',
      perguntas: [
        {
          pergunta: 'Quais são os planos disponíveis?',
          resposta: 'Oferecemos planos Pro (R$ 99/mês), Premium (R$ 299/mês) e Elite (R$ 999/mês). Cada plano oferece diferentes benefícios como destaques e leilões.',
        },
        {
          pergunta: 'Quais formas de pagamento são aceitas?',
          resposta: 'Aceitamos cartão de crédito, Pix e boleto bancário através dos nossos parceiros Stripe e PagSeguro.',
        },
        {
          pergunta: 'Posso cancelar meu plano?',
          resposta: 'Sim, você pode cancelar a qualquer momento pelo seu painel. O acesso premium continua até o fim do período já pago.',
        },
      ],
    },
    {
      categoria: 'Segurança',
      perguntas: [
        {
          pergunta: 'A BOILX é segura?',
          resposta: 'Sim! Utilizamos criptografia SSL, verificação de usuários e monitoramento constante para garantir a segurança da plataforma.',
        },
        {
          pergunta: 'Como denunciar um anúncio suspeito?',
          resposta: 'Em cada anúncio há um botão "Denunciar". Clique nele, selecione o motivo e nossa equipe analisará o caso em até 24 horas.',
        },
      ],
    },
  ];

  let globalIndex = 0;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Perguntas Frequentes</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            Encontre respostas para as dúvidas mais comuns.
          </p>
        </div>
      </div>

      <div className="container-custom py-12">
        <div className="max-w-3xl mx-auto">
          {faqs.map((categoria) => (
            <div key={categoria.categoria} className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">{categoria.categoria}</h2>
              <div className="space-y-3">
                {categoria.perguntas.map((faq) => {
                  const currentIndex = globalIndex++;
                  return (
                    <div key={currentIndex} className="bg-white rounded-xl shadow-sm overflow-hidden">
                      <button
                        onClick={() => setOpenIndex(openIndex === currentIndex ? null : currentIndex)}
                        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                      >
                        <span className="font-medium text-gray-900">{faq.pergunta}</span>
                        <svg
                          className={`w-5 h-5 text-gray-500 transition-transform ${openIndex === currentIndex ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {openIndex === currentIndex && (
                        <div className="px-6 pb-4">
                          <p className="text-gray-600">{faq.resposta}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* Contact CTA */}
          <div className="bg-green-50 rounded-2xl p-8 text-center mt-12">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Não encontrou sua resposta?</h3>
            <p className="text-gray-600 mb-4">Nossa equipe está pronta para ajudar.</p>
            <Link
              to="/contato"
              className="inline-block px-6 py-3 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition-colors"
            >
              Fale Conosco
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
